import React, { useEffect, useState } from "react";
import { NavigationButton, PrimaryButton } from "../../Buttons";
import Label from "../../Label";
import FormInputField from "../../FormInputField";
import OptionButton from "../../Common/OptionButton";
import CountriesInput from "../../Common/CountriesInput";
import useAllCountries from "../../../hooks/useAllCountries";
import Skeleton from "../../Common/Skeleton";

const CreateSubAccount = ({
  formData,
  onChange,
  handleCreateDraft,
  handleCancle,
  isLoading,
  isSumSubEnabled,
}) => {
  const allCountries = useAllCountries();
  const [country, setCountry] = useState("");

  // Initialize country based on formData or default to 223
  useEffect(() => {
    if (allCountries && allCountries.length > 0) {
      if (formData.country_code_id) {
        const found = allCountries.find(
          (c) => c.id === formData.country_code_id,
        );
        setCountry(found || allCountries[223]);
      } else {
        setCountry(allCountries[223]);
        // Set default in formData
        onChange({
          target: { name: "country_code_id", value: allCountries[223].id },
        });
      }
    }
  }, [allCountries, formData.country_code_id, onChange]);

  const updateAccountType = (val) => {
    onChange({ target: { name: "account_type", value: val } });
  };

  const handleCountryChange = (selectedCountry) => {
    setCountry(selectedCountry);
    onChange({
      target: { name: "country_code_id", value: selectedCountry.id },
    });
  };

  const isFormValid = () => {
    const isBasicDataValid =
      formData.name && formData.email_address && formData.account_type;

    if (isSumSubEnabled) {
      return isBasicDataValid;
    }
    return isBasicDataValid && formData.mobile_number;
  };

  return (
    <div className="w-full space-y-4 md:w-[450px]">
      <div>
        <Label
          className="block text-lg font-bold text-text-primary mb-1"
          text="Create Sub Account"
        />
        <p className="text-text-secondary text-sm">
          Enter the basic details to initialize the sub-account.
        </p>
      </div>

      {/* Name Input */}
      <FormInputField
        id="name"
        name="name"
        label="Your name / Business name"
        type="text"
        placeholder="Enter your full name or business name"
        value={formData.name || ""}
        onChange={onChange}
      />

      {/* Account Type (Side by Side) */}
      <div className="flex items-center justify-between space-x-3">
        <OptionButton
          label="Individual Account"
          value="individual"
          option={formData.account_type}
          setOption={updateAccountType}
        />
        <OptionButton
          label="Company Account"
          value="company"
          option={formData.account_type}
          setOption={updateAccountType}
        />
      </div>

      {/* Mobile Number (Country Select + Input) */}
      {!isSumSubEnabled && (
        <div className="flex items-center justify-between space-x-3">
          {allCountries.length > 0 && country ? (
            <CountriesInput
              id="country"
              countries={allCountries}
              SelectedCountry={country}
              onChange={handleCountryChange}
            >
              <div className="flex items-center justify-center space-x-3 px-4">
                {country.flag && (
                  <img
                    className="rounded-full w-8 h-8"
                    src={country.flag}
                    alt="flag"
                  />
                )}
                <Label
                  htmlFor="country"
                  className="text-sm font-medium text-text-primary"
                  text={`${
                    country.phonecode ? "+" + country.phonecode : "country"
                  }`}
                />
              </div>
            </CountriesInput>
          ) : (
            <Skeleton className="py-6 px-12 rounded-md" />
          )}

          <FormInputField
            id="mobile_number"
            name="mobile_number"
            label="Phone"
            type="number"
            placeholder="Enter phone number"
            value={formData.mobile_number || ""}
            onChange={onChange}
          />
        </div>
      )}

      {/* Email Input */}
      <FormInputField
        id="email_address"
        name="email_address"
        label="Email"
        type="email"
        placeholder="Enter your email"
        value={formData.email_address || ""}
        onChange={onChange}
      />

      <hr className="border border-divider my-4" />

      <div className="flex w-full space-x-3">
        <NavigationButton onClick={handleCancle} text="Cancel" />
        <PrimaryButton
          onClick={handleCreateDraft}
          text={isLoading ? "Creating..." : "Create & Continue"}
          disabled={!isFormValid() || isLoading}
        />
      </div>
    </div>
  );
};

export default CreateSubAccount;
